module.exports = __webpack_public_path__ + "static/media/32card-half.01a170be.png";